import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Form, Input, Switch, Select } from 'antd'
import UploadQiniu from '../../commponents/uploadQiniu/index'
import update from 'react-addons-update';
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './circle.less'
const FormItem = Form.Item;
const { Option } = Select;
const {TextArea} = Input
let dragingIndex = -1; 
class BodyRow extends React.Component {
	render() {
		const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
		const style = { ...restProps.style, cursor: 'move' };

		let { className } = restProps;
		if (isOver) {
			if (restProps.index > dragingIndex) {
				className += ' drop-over-downward';
			}
			if (restProps.index < dragingIndex) {
				className += ' drop-over-upward';
			}
		}

		return connectDragSource(
			connectDropTarget(<tr {...restProps} className={className} style={style} />),
		);
	}
}
const rowSource = {
	beginDrag(props) {
		dragingIndex = props.index;
		return {
			index: props.index,
		};
	},
};
const rowTarget = {
	drop(props, monitor) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;
		if (dragIndex === hoverIndex) {
			return;
		}
		props.moveRow(dragIndex, hoverIndex);
		monitor.getItem().index = hoverIndex;
	},
};
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
}))(
	DragSource('row', rowSource, connect => ({
		connectDragSource: connect.dragSource(),
	}))(BodyRow),
);
class Circle extends Component {
	constructor(props) {
		super(props)
		this.currentDom = React.createRef(null)
		this.state = {
			visible: false,
			bosObj: null,
			fileType: 'limit',
			scriptStatus: 'no',
			fileList: [],
			token: '',
			autoCompleteResult: [],
			modelTitel: '新增广告',
			qsCodeName: '',
			subjectIcon: '',
			introduction: '',
			circleType: 0,
			positionType: '',
			name: '',
			dataSource: [],
			notChanged: [],
			qiuniuUrl: '',
			columns: [
				
				{
					title: '广告图',
					dataIndex: 'pic',
					key: 'pic',
					align: 'center',
					render: (record)=> <img src={record} style={{width: '120px',height: '40px'}} alt=""/>
				},
				{
					title: '广告名称',
					dataIndex: 'name',
					key: 'name',
					align: 'center'
				},
				{
					title: '链接类型',
					dataIndex: 'type',
					key: 'type',
					align: 'center',
					render: (record,text)=> {
						if(text.type === 0) {
							return (
								<span>H5链接</span>
							)
						}
						if(text.type === 1) {
							return (
								<span>小程序内部链接</span>
							)
						}
						if(text.type === 2) {
							return (
								<span>第三方小程序链接</span>
							)
						}
					}
				},
				{
					title: '广告位置',
					dataIndex: 'positionType',
					key: 'positionType',
					align: 'center',
					render: (record,text)=> {
						if(text.positionType === 0) {
							return (
								<span>首页中部广告位</span>
							)
						}
						if(text.positionType === 1) {
							return (
								<span>资料广场广告位</span>
							)
						}
					}
				},
				{
					title: '创建人',
					dataIndex: 'admin',
					key: 'admin',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '启用状态',
					dataIndex: 'status',
					key: 'status',
					align: 'center',
					render: (record,text) => {
						return (
							<div>
								<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
									let id = text.id
									let arr = this.state.dataSource
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].status = checked===true? 1: 0
											this.setState({
												dataSource: arr
											})
										}
									}
									return (
										Modal.confirm({
											title: `${checked === true ? '启用广告' : '禁用广告'}`,
											okText: "确定",
											cancelText: "取消",
											content: (
												<div>
													<p>{checked === true ? '启用此广告将展示在小程序用以引流，确定要启用吗？' : '禁用后小程序将不再展示此广告，确定要禁用吗'}</p>
												</div>
											),
											onOk: () => {
												this.isRelease(id,checked,'ok')
											},
											onCancel: () => {
												this.isRelease(id,checked,'cancel')
											}
										})
									)
								}} />

							</div>
						)
					}
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						<span style={{marginRight:'15px',color: '#277FFF', cursor: 'pointer'}}  onClick={() => {
							this.setState({
								visible: true,
								modelTitel: '编辑广告',
								qsCodeName: record.name,
								linkAddr: record.linkAddr,
								appid: record.appid,
								advertId: record.id,
								circleType: record.type,
								positionType: record.positionType,
								subjectIcon: {
									uid: null,
									type: null,
									url: record.pic,
									name: record.name
								},
							})
						}}>编辑</span>
						
						{record.status !== 1?<span style={{color: '#277FFF', cursor: 'pointer'}} onClick={() => {
							Modal.confirm({
								title: '删除广告',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p>广告删除后将不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delAdvert(record.id)
								},
							});
						}}>删除</span>:''}
					</div>
				},
			]
		}
	}
	
	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			console.log(values)
		});
	}
	handleOk=(e)=> {
		this.props.form.validateFields((err, values) => {
			// console.log(values)
			// this.setState({ visible: false })
			if(!err) {
				if(this.state.modelTitel === '编辑广告'){
					let pic = values.circle.url&&values.circle.url ? values.circle.url :this.state.qiuniuUrl +'/'+ values.circle.response.key
					// console.log(pic)
					axios.post('advertController/update',{
						name: values.name,
						pic: pic,
						linkAddr: values.linkAddr,
						type: values.circleType,
						positionType: values.positionType,
						id: this.state.advertId,
						appid: values.appid
					}).then( res => {
						console.log(res)
						if(res.data.code === '200') {
							this.setState({visible: false})
							message.success('修改成功')
							this.getAdvertList()
						}else{
							message.error(res.data.msg)
						}
					})
				}else if(this.state.modelTitel === '新增广告') {
					axios.post('advertController/add',{
						name: values.name,
						pic: this.state.qiuniuUrl+'/'+ values.circle.response.key,
						linkAddr: values.linkAddr,
						type: values.circleType,
						positionType: values.positionType,
						id: '',
						appid: values.appid
					}).then( res => {
						console.log(res)
						if(res.data.code === '200') {
							this.setState({visible: false})
							message.success('新增成功')
							this.getAdvertList()
						}else{
							message.error(res.data.msg)
						}
					})
				}
			}
		});
	}
	componentDidMount() {
		this.getAdvertList()
		console.log(this.currentDom)
	}
	showModal() {
		this.setState({ visible: true, modelTitel: '新增广告', circleType: 1, name: '', linkAddr: '',appid: '' })
	}
	isRelease(id,checked,type) {
		if(type === 'ok'){
			axios.post('advertController/publish',{
				id: id,
				status: checked === true ? 1 : 0
			}).then( res => {
				if(res.data.code === '200') {
					message.success('操作成功')
					this.getAdvertList()
				}else {
					message.error(res.data.msg)
				}
			})
		}else if(type === 'cancel') {
			this.getAdvertList()
		}
	}
	getUploadUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	async getAdvertList() {
		axios.post('advertController/getList',{
			pageSize: 100,
			pageNum: 1,
			name: this.state.name
		}).then( res => {
			if(res.data.code === '200'){
				this.setState({
					dataSource: res.data.data.list,
					notChanged: res.data.data.list
				})
			}
		})
	}
	delAdvert(id) {
		axios.get(`advertController/del/${id}`).then( res => {
			if(res.data.code === '200'){
				message.success('删除成功')
				this.getAdvertList()
			}else {
				message.error(res.data.msg)
			}
		})
	}
	getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	components ={
		body: {
			row: DragableBodyRow,
		},
	};
	moveRow = (dragIndex, hoverIndex) => { 
		const { dataSource } = this.state;
		const dragRow = dataSource[dragIndex];
		this.setState(
			update(this.state, {
				dataSource: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
		let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.dataSource[i].id })
		}
		axios.post('/advertController/updateSort',oldSort).then(res => {
			if(res.data.code === '200' ){
				this.getAdvertList()
				message.success('更新排序成功')
			}else {
				message.error(res.data.msg)
			}
			oldSort = []
		})
	};


	render() {
		
		const { visible, dataSource, columns, modelTitel, subjectIcon, linkAddr, positionType, qsCodeName, name, circleType,appid } = this.state;
		const { getFieldDecorator } = this.props.form
		return (
			<div className="circle">
				<span style={{display: 'flex', alignItems: 'center',fontSize: '18px',fontWeight: '600'}}>广告管理</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between',marginBottom: '20px' }}>
					<div>
						<Input allowClear value={name} style={{width: '260px',height: '40px',marginRight: '20px'}} placeholder="请输入广告名称" onChange={(e)=>{
							this.setState({
								name: e.target.value
							})
						}}></Input>
						<Button className='my-button-primary' style={{marginRight: '20px'}} onClick={()=>{
							this.getAdvertList()
						}} type='primary'>搜索</Button>
						<span className='my-button-txt' onClick={()=>{
							this.setState({name: ''},()=>{
								this.getAdvertList()
							})
						}} >重置</span>
					</div>
					<Button className='my-button-primary' type='primary'  onClick={() => { this.showModal() }}>新增广告</Button>
				</div>
				<DndProvider backend={HTML5Backend}>
					<Table dataSource={dataSource} columns={columns} 
				    	components={this.components}
						rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
						rowKey={record => record.id}
						onRow={(record, index) => ({
							index,
							moveRow: this.moveRow,
						})}
					/>
				</DndProvider>
				<Modal
					getContainer={false}
					title={modelTitel}
					okText="确认"
					cancelText="取消"
					visible={visible}
					maskClosable={false}
					destroyOnClose
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk}>
						<FormItem label={"广告名称"}>
							{getFieldDecorator('name', {initialValue: modelTitel==='编辑广告'? qsCodeName: '',
								rules: [{ required: true, message: '请输入广告名称!' },{max: 50, message: '最多输入50个字符'}],
							})(
								<Input placeholder='请输入广告名称' />
							)}
						</FormItem>
						<Form.Item label="广告">
							{getFieldDecorator('circle', {
								initialValue: modelTitel==='编辑广告'? subjectIcon: '',

								rules: [{ type: 'object', required: true, message: '请上传广告!' }],
							})(
								<UploadQiniu getQiniuUrl={this.getQiniuUrl} />
							)}
						</Form.Item>
						<Form.Item label="链接类型">
							{getFieldDecorator('circleType', {
								rules: [{ required: true, message: '请选择链接类型' }],
								initialValue: modelTitel==='编辑广告'? circleType: circleType
							})(
								<Select
									placeholder="请选择链接类型"
									onChange={(val) => {
                    this.setState({
                      circleType: val
                    })
                  }}
								>
									<Option value={0}>H5链接</Option>
									<Option value={1}>小程序内部链接</Option>
									<Option value={2}>第三方小程序链接</Option>
								</Select>
							)}
						</Form.Item>
						<FormItem label={"广告链接"}>
							{getFieldDecorator('linkAddr',{initialValue: modelTitel==='编辑广告'? linkAddr: '',
							rules: [{required: true, message: '请输入广告链接'}]
						})(
								<TextArea style={{width: '100%'}} maxLength={200} placeholder='请输入广告链接' />
							)}
						</FormItem>
					  {circleType === 2?<FormItem label={"AppID"}>
							{getFieldDecorator('appid',{initialValue: modelTitel==='编辑广告'? appid: '',
							rules: [{required: true, message: '请输入AppID'}]
						})(
								<Input style={{width: '100%'}} maxLength={200} placeholder='请输入AppID' />
							)}
						</FormItem>:''}
						<Form.Item label="广告位置">
							{getFieldDecorator('positionType', {
								rules: [{ required: true, message: '请选择广告位置' }],
								initialValue: modelTitel==='编辑广告'? positionType: ''
							})(
								<Select
									placeholder="请选择广告位置"
								>
									<Option value={0}>首页中部广告位</Option>
									<Option value={1}>资料广场广告位</Option>
								</Select>
							)}
						</Form.Item>
					</Form>
				</Modal>
			</div>
		)
	}
}



export default Form.create()(Circle)